export default __webpack_public_path__ + "static/media/task-outline-16-px.0ba357b2.svg";